module.exports = __webpack_public_path__ + "img/yipu_logo.6a7c9bcf.png";